import fetch from 'isomorphic-fetch'

const fetcher = {
  baseUrl(productLandingPageSlug) {
    return `/services/${productLandingPageSlug}/directory`
  },

  csrfToken() {
    return $('meta[name="csrf-token"]').attr('content')
  },

  updateServices(productLandingPageSlug, serviceId, remove) {
    if(remove) {
      return this.removeService(productLandingPageSlug, serviceId)
    } else {
      return this.addService(productLandingPageSlug, serviceId)
    }
  },

  addService(productLandingPageSlug, serviceId) {
    return this.fetcher(productLandingPageSlug, serviceId, 'POST')
  },

  removeService(productLandingPageSlug, serviceId, clearAll = false) {
    return this.fetcher(productLandingPageSlug, serviceId, 'DELETE', clearAll)
  },

  fetcher(productLandingPageSlug, serviceId, method, clearAll) {
    return fetch(this.baseUrl(productLandingPageSlug), {
      method: method,
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-CSRF-TOKEN': this.csrfToken()
      },
      redirect: 'follow',
      referrer: 'no-referrer',
      body: JSON.stringify({service_id: serviceId}, {clear_all: clearAll})
    }).then((response) => {
      if (response.status >= 400) {
        throw new Error('Bad response from server')
      }
      return response.json()
    }).then((data) => data)
  }
}

export default fetcher
